/**
 * Lightweight BCP-47 tag parsing for locale codes we use (e.g. `en-US`, `ja-JP`, `de`).
 */
export const getTrimmedLocaleCode = (localeCode) => localeCode.trim();
const parseLanguageSubtag = (trimmedLocaleCode) => {
    const languageSubtag = trimmedLocaleCode.split("-")[0]?.toLowerCase();
    return languageSubtag && /^[a-z]{2}$/.test(languageSubtag) ? languageSubtag : null;
};
const parseRegionSubtag = (trimmedLocaleCode) => {
    const parts = trimmedLocaleCode.split("-");
    if (parts.length < 2) {
        return null;
    }
    const regionSubtag = parts[parts.length - 1];
    return regionSubtag && /^[a-zA-Z]{2}$/.test(regionSubtag) ? regionSubtag.toUpperCase() : null;
};
export const parseLocaleCode = (localeCode) => {
    const trimmedLocaleCode = getTrimmedLocaleCode(localeCode);
    if (!trimmedLocaleCode) {
        return { trimmedLocaleCode: "", language: null, region: null };
    }
    return {
        trimmedLocaleCode,
        language: parseLanguageSubtag(trimmedLocaleCode),
        region: parseRegionSubtag(trimmedLocaleCode),
    };
};
export const getLanguageSubtagFromLocaleCode = (localeCode, fallback = "en") => {
    const { trimmedLocaleCode, language } = parseLocaleCode(localeCode);
    if (!trimmedLocaleCode) {
        return fallback;
    }
    return language ?? fallback;
};
export const getRegionSubtagFromLocaleCode = (localeCode) => parseLocaleCode(localeCode).region;
/** Region subtag when present, otherwise ISO 639-1 language subtag. */
export const getRegionOrLanguageFilterKeyFromLocaleCode = (localeCode) => {
    const { trimmedLocaleCode, language, region } = parseLocaleCode(localeCode);
    if (!trimmedLocaleCode) {
        return null;
    }
    return region ?? language;
};
//# sourceMappingURL=bcp47LocaleTags.js.map